import { rankingItems } from '@/mocks/home';

export default function RankingSection() {
  return (
    <section id="ranking" className="section-padding bg-background-50">
      <div className="section-container">
        <div className="flex items-center justify-between mb-8">
          <div>
            <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-900">
              黑料排行榜
              <span className="ml-3 text-sm font-body font-normal text-foreground-500">实时热度</span>
            </h2>
          </div>
          <div className="flex items-center gap-1 px-3 py-1.5 rounded-full bg-primary-100/70 text-primary-600 text-xs font-medium">
            <span className="w-1.5 h-1.5 rounded-full bg-primary-500 animate-pulse"></span>
            每5分钟更新
          </div>
        </div>

        <div className="space-y-3">
          {rankingItems.map((item, i) => (
            <div
              key={i}
              className="group flex items-center gap-3 md:gap-5 p-4 md:p-5 rounded-xl bg-background-100 hover:bg-background-200/70 transition-colors cursor-pointer"
            >
              {/* Rank */}
              <div className={`flex-shrink-0 w-10 h-10 md:w-12 md:h-12 rounded-xl flex items-center justify-center font-heading font-bold text-lg ${
                i < 3
                  ? 'bg-primary-500 text-background-50'
                  : 'bg-background-200 text-foreground-600'
              }`}>
                {item.rank}
              </div>

              {/* Content */}
              <div className="flex-1 min-w-0">
                <div className="flex items-center gap-2 flex-wrap">
                  <h3 className="text-sm md:text-base font-semibold text-foreground-900 group-hover:text-primary-500 transition-colors">
                    {item.title}
                  </h3>
                  <span className={`flex-shrink-0 px-2 py-0.5 rounded-full text-[10px] font-bold ${
                    item.tag === '爆'
                      ? 'bg-primary-500 text-background-50'
                      : item.tag === '新'
                      ? 'bg-accent-500 text-background-50'
                      : 'bg-secondary-200 text-secondary-800'
                  }`}>
                    {item.tag}
                  </span>
                </div>
                <div className="flex items-center gap-3 mt-1.5 text-xs text-foreground-500">
                  <span className="flex items-center gap-1">
                    <i className="ri-fire-line text-primary-400"></i>
                    {item.heat}热度
                  </span>
                  <span>{item.time}</span>
                  <span className={`font-semibold ${item.trend === 'up' ? 'text-primary-500' : 'text-secondary-500'}`}>
                    {item.trendValue}
                  </span>
                </div>
              </div>

              {/* Arrow */}
              <div className="flex-shrink-0 w-8 h-8 flex items-center justify-center opacity-0 group-hover:opacity-100 transition-opacity">
                <i className="ri-arrow-right-s-line text-foreground-400 text-xl"></i>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}